<div class="allImgcontainer" [ngStyle]="portalbannerConfig?{'background': 'url(' + bgImage + ') no-repeat center center fixed', 'background-size': 'cover'  }:''">
    <app-news-feed-component *ngIf="ischeckPermissions('ViewNewsfeed')" ></app-news-feed-component>
</div>
